<template>
	<span :title="model">
		<v-text-field
			:hint="hint"
			persistent-hint
			type="number"
			v-model="model"
			min="0"
			@input="update()"
			:disabled="inputDisabled"
			:label="label"
			:rules="computedRules"
		></v-text-field>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	computed: {
		computedRules() {
			let res = []
			if (this.rules) {
				res = this.rules.concat([])
			}
			if (this.inputRequired) {
				res.push((v) => (v !== null && v !== undefined) || this.label + ' requis')
			}
			return res
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/numberInput.vue